export const TYPE_MENU_DEFAULT_INFO = {
  selectedMenuKeys: ["0"],
  filteredMenuItems: [
    {
      feeTypeId: 0,
      feeTypeName: "",
    },
  ],
};
